import { useEffect } from 'react'
import { Link, useLoaderData } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { getNews } from '../../../actions/news.action'
import { isRightAccess } from '../../../utils'
import { RIGHTS_BLOG_LIST, RIGHTS_MODIFY_OR_ADD_BLOG } from '../../../utils/env'

import PropTypes from 'prop-types'

import Login from '../../../components/Login'
import Header from '../../../components/Header'
import TextNewsEdit from '../../../components/TextNewsEdit'
import Fieldset from '../../../components/Fieldset'

import Error403 from '../../Error/403'

import './index.scss'

function AdminNewsHandler() {
	const user = useSelector((state) => state.userReducer)
	const newsList = useSelector((state) => state.newsReducer.list)
	const data = useLoaderData()
	const modifyId = parseInt(data.modifyId)
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(getNews())
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<>
			{user.isConnected ? (
				<div className="SOUKIASSIAN-Blog">
					<Header type="admin" />
					{modifyId === 0 && isRightAccess(user, RIGHTS_BLOG_LIST) ? (
						<section className="SOUKIASSIAN-Blog-section col-max-blocked center">
							<h1>Ajouter ou modifier une actualité</h1>
							{newsList &&
								newsList.map((news) => (
									<Link to={`${news.id}`}>
										<Fieldset
											key={`newsList_${news.id}`}
											legend={`Titre de l'actualité N° ${news.id}`}
											text={news.title}
										/>
									</Link>
								))}
						</section>
					) : (
						<>
							{modifyId === 0 && (
								<Error403 redirectLink="/admin/home" />
							)}
						</>
					)}
					{modifyId &&
						modifyId !== 0 &&
						isRightAccess(user, RIGHTS_MODIFY_OR_ADD_BLOG) && (
							<section className="SOUKIASSIAN-Blog-section col-max-blocked center">
								<h1>{`Modifier l'actualité N° ${modifyId}`}</h1>
								<Fieldset
									legend={`Titre de l'actualité`}
									text={
										<TextNewsEdit
											newsId={modifyId}
											textName="title"
										/>
									}
								/>
								<Fieldset
									legend={`Texte de l'actualité`}
									text={
										<TextNewsEdit
											newsId={modifyId}
											textName="text"
										/>
									}
								/>
							</section>
						)}
				</div>
			) : (
				<Login />
			)}
		</>
	)
}

AdminNewsHandler.propTypes = {
	modifyId: PropTypes.number,
}

AdminNewsHandler.defaultProps = {
	modifyId: 0,
}

export default AdminNewsHandler
